import React, { useState } from 'react';
import DateRangeDisplay from './DateRangeDisplay/DateRangeDisplay';
import WidgetContainer from './WidgetContainer';
import { IDateInput } from '../../../redux/slices/oldBuilder/date/types';
import { MaybeNil } from '../../../utils/interfaces';
import { GraphQLDate } from '../../../utils/types';
import {
  KubitPopover,
  KubitPopoverContent,
  KubitPopoverTrigger,
} from '../../KubitPopover';

interface IProps {
  /**
   * Schema ID is used to calculate relative time periods according to the
   * schema's week start. We should strive to pass it all the time in order
   * to set the right expectations for the user. Very occasionally
   * we don't have concept of schema in the place where we use it (e.g.
   * Incidents search) thus we allow passing null as an exception.
   * In this case, Kobol calculates the absolute time period based on the
   * default schema of the client
   */
  schemaId: MaybeNil<string>;
  endDate: GraphQLDate;
  dateInput: IDateInput;
  onChange: (newDateInput: IDateInput) => void;
}

/**
 * New Date Picker component including of Date Range and Time Unit Selectors
 */
export default ({ schemaId, dateInput, onChange, endDate }: IProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const handleConfirm = (dateInput: IDateInput) => {
    setIsPopoverOpen(false);
    onChange(dateInput);
  };

  return (
    <KubitPopover isOpen={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <KubitPopoverTrigger asChild={true}>
        <div>
          <DateRangeDisplay dateInput={dateInput} />
        </div>
      </KubitPopoverTrigger>
      <KubitPopoverContent>
        <WidgetContainer
          endDate={endDate}
          onConfirm={handleConfirm}
          dateInput={dateInput}
          schemaId={schemaId}
        />
      </KubitPopoverContent>
    </KubitPopover>
  );
};
